<template>
  <div class="headerContainer">
    <div
      class="headerWrapper"
      :class="{ backColor: isColor, 'ig-shadow-b1': border, redBack: isLight }"
      :style="{ top: top }"
    >
      <div class="headerLeft" :class="{ 'min-width-220': minWidth == 22 }">
        <div class="backBtn" @click.stop="backFn" v-if="isApp || showBack">
          <img
            v-if="isXue"
            class="close"
            src="@/assets/icon/close_ic.svg"
            alt=""
          />
          <img
            v-else-if="isLight"
            class="lightIcon"
            src="@/assets/icon/back_light.png"
            alt=""
          />
          <img v-else src="@/assets/icon/icon_left.png" alt="" />
        </div>
        <slot name="timer" v-if="!isXue"></slot>
      </div>
      <div class="listBox" v-show="list.length" ref="listScroll">
        <ul class="subdep-list" :style="{ width: scrollWidth }" ref="list">
          <li
            :class="{
              active: item.id === typeId,
              depActiveIndex: item.id == typeId
            }"
            :ref="item.id === typeId ? 'active' : ''"
            class="text-overflow"
            @click.stop="checkType(item.id)"
            v-for="item in list"
            :key="item.id"
          >
            <span>{{ item.name }}</span>
            <div class="line"></div>
          </li>
        </ul>
      </div>
      <div class="pageTitle text-overflow" v-show="pageTitle">
        {{ pageTitle }}
      </div>
      <div
        class="headerRight"
        v-show="!list.length"
        :class="{ 'min-width-220': minWidth == 22 }"
      >
        <slot name="cancelOrder"></slot>
        <slot name="collect"></slot>
        <slot name="reportBtn"></slot>
        <slot name="shareBtn"></slot>
        <slot name="timer" v-if="isXue"></slot>
      </div>
    </div>
  </div>
</template>

<script>
import BScroll from '@better-scroll/core'
import { defineComponent } from 'vue'
import { appPort, iOSPort, androidPort } from '@/widget/index'

export default defineComponent({
  props: {
    list: {
      type: Array,
      default() {
        return []
      }
    },
    typeId: {
      default: 1,
      type: Number
    },
    pageTitle: {
      type: String,
      default: ''
    },
    minWidth: {
      type: Number,
      default: 0
    },
    showBack: {
      default: false,
      type: Boolean
    },
    isColor: {
      default: true,
      type: Boolean
    },
    isXue: {
      default: false,
      type: Boolean
    },
    border: {
      default: true,
      type: Boolean
    },
    top: {
      default: '0px',
      type: String
    },
    isLight: {
      default: false,
      type: Boolean
    }
  },
  data() {
    return {
      scrollWidth: '6.56rem',
      totalWidth: 10,
      bs: null,
      isApp: appPort()
    }
  },
  watch: {
    list(newData) {
      if (newData.length) {
        this.$nextTick(() => {
          this.setWidth()
          setTimeout(() => {
            this.bs = new BScroll(this.$refs.listScroll, {
              scrollY: false,
              scrollX: true,
              click: true
            })
            let dom = document.querySelector('.depActiveIndex')
            if (dom) {
              let x =
                dom.offsetLeft * -1 + dom.offsetWidth > 0
                  ? 0
                  : dom.offsetLeft * -1 + 120
              this.bs.scrollTo(x, 0)
            }
          })
        })
      } else {
        this.bs && this.bs.destroy()
      }
    }
  },
  methods: {
    backFn() {
      if (this.$attrs.onBackFn) {
        this.$emit('backFn')
        return
      }
      if (this.isApp) {
        const data = { type: 'webViewBack' }
        if (androidPort()) {
          window.JavaScriptInterface.mobileApi(JSON.stringify(data))
        } else if (iOSPort()) {
          window.webkit.messageHandlers.mobileApi.postMessage(data)
        }
      } else {
        const url = this.$route.query.backUrl
        if (url) {
          location.assign(url)
        } else {
          history.go(-1)
        }
      }
    },
    setWidth() {
      let doms = this.$refs.list.children
      this.totalWidth = 0
      for (var ind in doms) {
        this.totalWidth += Number(doms[ind].offsetWidth) || 0
      }
      this.totalWidth += 20
      const rem = Number(localStorage.getItem('rem'))
      this.scrollWidth = this.totalWidth / rem + 'rem'
    },
    checkType(id) {
      this.$emit('changeType', id)
      this.setWidth()
      this.$nextTick(() => {
        this.bs && this.bs.refresh()
      })
    }
  }
})
</script>

<style lang="scss" scoped>
.headerContainer {
  height: 88px;
  .headerWrapper {
    height: 88px;
    position: fixed;
    top: 0;
    width: 750px;
    margin-left: -375px;
    left: 50%;
    display: flex;

    box-sizing: border-box;
    z-index: 996;
    justify-content: space-between;
  }
  .backColor {
    background: #f5f5f7;
  }
  .redBack {
    background: #ff3c47;
    .pageTitle {
      color: #ffffff;
    }
  }
  .backBtn {
    height: 88px;
    line-height: 88px;
    padding: 0 40px 0 32px;
    overflow: hidden;
    .lightIcon {
      width: 0.45rem;
      height: 0.52rem;
    }
    img {
      width: 22px;
      height: 40px;
      margin-top: 22px;
    }
    .close {
      width: 56px;
      height: 56px;
    }
  }
  .listBox {
    width: 750 - 94px;
    overflow: hidden;
    .subdep-list {
      height: 88px;
      li {
        height: 88px;
        min-width: 84px;
        float: left;
        line-height: 88px;
        font-size: 32px;
        color: $gray96;
        position: relative;
        text-align: center;
        padding: 0 20px;
        .line {
          width: 44px;
          height: 6px;
          border-radius: 3px;
          display: none;
          position: absolute;
          bottom: 0;
          left: 50%;
          margin-left: -22px;
          background: $themeColor;
          z-index: 9;
        }
      }
      li.active {
        font-size: 40px;
        font-family: PingFangSC-Bold, PingFang SC;
        color: $black;
        font-weight: bold;
        .line {
          display: block;
        }
      }
    }
  }
  .pageTitle {
    text-align: center;
    line-height: 88px;
    font-size: 36px;
    font-weight: 500;
    flex: 1;
  }
  .headerRight,
  .headerLeft {
    min-width: 88px;
    display: flex;
    align-items: center;
  }
  .min-width-220 {
    min-width: 220px;
  }
}
</style>
